/**
 * @file EditCaraResponseModal.jsx
 * @description EditCaraResponseModal component for displaying and managing edit cara response modal.
 * @component EditCaraResponseModal
 * @exports EditCaraResponseModal - Main component for displaying and managing edit cara response modal.
 */

import { Button, Checkbox, FormControlLabel, TextField } from "@mui/material";
import React from "react";
import DialogComponent from "../../../common/components/DialogComponent";
import { TEXT_STRING } from "../../../common/constants/agentModule/textConstants";
import { STRINGS, VARIANTS } from "../../../common/constants/commonConstants";

const EditCaraResponseModal = ({
  open,
  selectedChat,
  onClose,
  onSave,
  onTextChange,
  onCheckBoxChange,
}) => {

  return (
    <div>
      <DialogComponent
        title={TEXT_STRING.EDIT_CARA_RESPONSE_HEADER}
        open={open}
        onClose={onClose}
        actions={
          <Button variant={VARIANTS.CONTAINED} onClick={onSave}>
            {STRINGS.SAVE}
          </Button>
        }
      >
        <TextField
          fullWidth
          multiline
          minRows={3}
          maxRows={6}
          value={selectedChat?.cararesponse || ""}
          onChange={(e) => onTextChange(e.target.value)}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={selectedChat?.cararesponseapproved === 1}
              onChange={(e) => onCheckBoxChange(e.target.checked ? 1 : 0)}
            />
          }
          label={TEXT_STRING.APPROVE_RESPONSE_LABEL}
        />
      </DialogComponent>
    </div>
  );
};

export default EditCaraResponseModal;
